// react
import React, { Component, useRef } from 'react';
import EmptyState from '../shared/EmptyState';

// third-party
import classNames from 'classnames';
import { connect, useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { Row, Col, Card, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import axios from 'axios';

// application
import AsyncAction from '../shared/AsyncAction';
// import Currency from '../shared/Currency';
// import InputNumber from '../shared/InputNumber';
import PageHeader from '../shared/PageHeader';
// import { cartRemoveItem, cartUpdateQuantities } from '../../store/cart';
import { Check9x7Svg, Cross12Svg } from '../../svg';
// import { url } from '../../services/utils';
import Collapse from '../shared/Collapse';


// data stubs
import theme from '../../data/theme';
import payments from '../../data/shopPayments';

import { toast } from 'react-toastify';
import { updateAction } from '../../store/auth/authActions';
import { initOrderTimer } from '../../services/orderTimer';
// import { WindowSharp } from '@mui/icons-material';

function historyFunc(Component) {
  function historyFunc(props) {
    let history = useHistory()
    return <Component history={history} {...props} />
  }
  return historyFunc

}
function dispatchFunc(Component) {
  function dispatchFunc(props) {
    let dispatch = useDispatch()
    return <Component dispatch={dispatch} {...props} />
  }
  return dispatchFunc

}

class ShopPageCheckout extends Component {
  payments = payments;

  constructor(props) {
    super(props);

    // this.state = {
    //     /** example: [{itemId: 8, value: 1}] */
    //     quantities: [],
    //     cart:false,
    //     totalPrice:0,
    //     cart_id:[],
    //     payment: "BANK_TRANSFER",
    //     loadingCO: false,
    //     paid: false,
    //     address_id: false,
    // };

    this.state = {
      loadingInit: true,
      listkurir: [],
      quantities: [],
      // cart: [],
      listItem: [],
      id: [],
      totalPrice: 0,
      totalOngkir: 0,
      cart_id: [],
      list_so: [],
      payment: "863.101.3333",
      loadingCO: false,
      paid: false,
      addressData: false,
      address_id: false,
      showOtherAddresses: false,
      courier: [],
      per_kg: 0,
      open: false,
      listBank: [],
      show: false,
      loadingOngkir: false,
      loadingOngkirId: null,
    };
    this.ongkirRequestId = 0;
    this.itemRequestVersions = {};
  }

  getActiveToken = () => {
    if (this.props.token) return this.props.token;
    try {
      const stored = JSON.parse(localStorage.getItem('state') || '{}');
      const found = stored?.auth?.token || localStorage.getItem('token');
      if (found) {
        localStorage.setItem('token', found);
        return found;
      }
    } catch (e) {
      return localStorage.getItem('token');
    }
    return localStorage.getItem('token');
  };

  componentDidMount() {
    const { token, updateStatus } = this.props
    // const getCart = async () => {
    //     const result = await axios({
    //       method: "GET",
    //       url: `${process.env.REACT_APP_HOST_API}/cart/list`,
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     });
    //     console.log(result.data?.response);
    //     this.setState({cart:result.data?.response});
    //     this.setState({cart_id:result.data?.response.map((item)=> item.id)});
    //     console.log(result.data?.response.map((item)=> item.id));
    //     const totalPrice = result.data?.response.map((item) => item.sub_total);
    //     // console.log(totalPrice);
    //     let sum = 0;

    //     for (let i = 0; i < totalPrice.length; i++) {
    //       sum += totalPrice[i];
    //     }
    //     this.setState({totalPrice: sum});
    //     const productQuantity=result.data?.response.map(({id, qty}) => {
    //         return {itemId:id,value:qty}
    //     })
    //     this.setState({quantities: productQuantity})
    //     console.log(this.state.quantities);
    //   };
    const getSo = async (expectedRequestId = null, expectedAddressId = null) => {
      const activeToken = this.getActiveToken();
      if (!activeToken) return;
      try {
        const result = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_HOST_API}/so-commerce/list-by-user`,
          headers: {
            Authorization: `Bearer ${activeToken}`,
          },
        });

        // Guard: jika request ini superseded oleh gonta-ganti alamat atau kurir baru
        if (expectedRequestId !== null && this.ongkirRequestId !== expectedRequestId) {
          return;
        }
        if (expectedAddressId !== null && String(this.state.address_id) !== String(expectedAddressId)) {
          return;
        }

        let data = [];
        if (Array.isArray(result.data?.response)) {
          data = result.data.response;
        } else if (result.data?.response && typeof result.data.response === 'object') {
          data = [result.data.response];
        }

        const currentListKurir = Array.isArray(this.state.listkurir) ? this.state.listkurir : [];

        // Gabungkan dengan state terkini: jika suatu item di-reset ke 0 (karena ganti alamat / kurir belum dipilih),
        // jangan biarkan data lama dari backend membangkitkan kurir / ongkir lama
        const mergedData = data.map((item) => {
          const currentEntry = currentListKurir.find((k) => k.id === item.id);
          if (currentEntry && Number(currentEntry.value) === 0) {
            const itemsSum = Array.isArray(item.items)
              ? item.items.reduce((acc, it) => acc + (parseFloat(it.sub_total) || 0), 0)
              : 0;
            const prodSub = itemsSum > 0
              ? itemsSum
              : Math.max(0, (parseFloat(item.sub_total_so) || parseFloat(item.payment_total) || 0) - (parseFloat(item.ongkir) || 0));

            return {
              ...item,
              kurir_id: 0,
              ongkir: null,
              payment_total: prodSub,
            };
          }
          return item;
        });

        const kurircok = mergedData.map(({ id, kurir_id }) => {
          const currentEntry = currentListKurir.find((k) => k.id === id);
          if (currentEntry && Number(currentEntry.value) === 0) {
            return { id, value: 0 };
          }
          return { id, value: kurir_id || 0 };
        });

        let totalOngkirSum = 0;
        let totalPriceSum = 0;

        mergedData.forEach((item) => {
          if (item.ongkir !== null && item.ongkir !== undefined) {
            totalOngkirSum += (parseFloat(item.ongkir) || 0);
          }
          totalPriceSum += (parseFloat(item.payment_total) || 0);
        });

        this.setState({
          listItem: mergedData,
          list_so: mergedData.map((item) => item.id),
          totalPrice: totalPriceSum,
          listkurir: kurircok,
          totalOngkir: totalOngkirSum,
        });
      } catch (error) {
        console.error('getSo error:', error);
        this.setState({ listItem: [], list_so: [], totalPrice: 0, listkurir: [], totalOngkir: 0 });
      }
    };
    this.getSo = getSo;

    const getAddress = async () => {
      const activeToken = this.getActiveToken();
      if (!activeToken) return;
      try {
        const result = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_HOST_API}/address/list/`,
          headers: {
            Authorization: `Bearer ${activeToken}`,
          },
        });
        const rawList = Array.isArray(result.data?.response) ? result.data.response : [];
        const savedDefaultId = localStorage.getItem('DEFAULT_ADDRESS_ID');
        const sessionAddrId =
          sessionStorage.getItem('CHECKOUT_SELECTED_ADDRESS_ID') ||
          localStorage.getItem('CHECKOUT_SELECTED_ADDRESS_ID');

        let chosenAddr = null;

        // 1. Prioritize active selection in state or session
        const currentActiveId = this.state.address_id || sessionAddrId;
        if (currentActiveId) {
          chosenAddr = rawList.find((a) => String(a.address_id) === String(currentActiveId));
        }

        // 2. Prioritize default address configured in /account/addresses
        if (!chosenAddr && savedDefaultId) {
          chosenAddr = rawList.find((a) => String(a.address_id) === String(savedDefaultId));
        }

        // 3. Fallback to address marked is_default: 0 or '0' (Hokky backend standard)
        if (!chosenAddr) {
          chosenAddr =
            rawList.find((a) => a.is_default === 0 || a.is_default === '0') ||
            rawList.find((a) => a.is_default === 1 || a.is_default === true) ||
            rawList[0];
        }

        const activeId = chosenAddr ? chosenAddr.address_id : (rawList[0]?.address_id || false);

        if (activeId) {
          sessionStorage.setItem('CHECKOUT_SELECTED_ADDRESS_ID', String(activeId));
          localStorage.setItem('CHECKOUT_SELECTED_ADDRESS_ID', String(activeId));
        }

        // Tampilkan data awal agar UI checkout langsung muncul seketika
        this.setState((prev) => ({
          addressData: rawList,
          address_id: prev.address_id || activeId,
        }));

        // Enrich setiap alamat dengan detail dari /address/get/{id} agar latitude & longitude tersedia
        if (rawList.length > 0) {
          try {
            const enrichedList = await Promise.all(
              rawList.map(async (item) => {
                try {
                  const detailRes = await axios({
                    method: 'GET',
                    url: `${process.env.REACT_APP_HOST_API}/address/get/${item.address_id}`,
                    headers: {
                      Authorization: `Bearer ${activeToken}`,
                    },
                  });
                  const detail = detailRes.data?.response;
                  if (detail) {
                    return {
                      ...item,
                      ...detail,
                      address_id: item.address_id,
                      address_name: item.address_name || detail.address || '',
                      recipient_name: item.recipient_name || detail.recipient_name || detail.name || '',
                      phone: item.phone || detail.phone || '',
                      latitude: detail.latitude !== undefined && detail.latitude !== null ? detail.latitude : item.latitude,
                      longitude: detail.longitude !== undefined && detail.longitude !== null ? detail.longitude : item.longitude,
                    };
                  }
                } catch (err) {
                  // abaikan error individual
                }
                return item;
              })
            );

            this.setState({
              addressData: enrichedList,
            });
          } catch (e) {
            console.warn('Enrich address list error:', e);
          }
        }
      } catch (error) {
        toast.error('There was an error!');
      }
    };
    this.getAddress = getAddress;

    const getCourier = async () => {
      const activeToken = this.getActiveToken();
      if (!activeToken) return;
      try {
        const result = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_HOST_API}/kurir/aktif`,
          headers: {
            Authorization: `Bearer ${activeToken}`,
          },
        });
        this.setState({ courier: result.data?.response });
        this.setState({ per_kg: result.data?.response[0].per_kg });
      } catch (error) {
        // console.log(error);
        toast.error('There was an error!');
      }
    };
    this.getCourier = getCourier;

    const getBankList = async () => {
      const activeToken = this.getActiveToken();
      if (!activeToken) return;
      try {
        const result = await axios({
          method: "GET",
          url: `${process.env.REACT_APP_HOST_API}/bank/list`,
          headers: {
            Authorization: `Bearer ${activeToken}`,
          },
        });
        const banks = result.data?.response || [];
        const currentPay = this.state.payment;
        const validPayment = Array.isArray(banks) && banks.some((b) => b.account_number === currentPay);
        this.setState({
          listBank: banks,
          payment: validPayment ? currentPay : (banks[0]?.account_number || ""),
        });
      } catch (err) {
        console.error("Failed to load bank list:", err);
      }
    };
    this.getBankList = getBankList;

    const activeToken = this.getActiveToken();
    if (activeToken) {
      Promise.allSettled([
        getSo(),
        getAddress(),
        getCourier(),
        getBankList(),
      ]).finally(() => {
        this.setState({ loadingInit: false });
      });
    } else {
      this.setState({ loadingInit: false });
    }

    // Real-time synchronization when default address is updated from /account/addresses
    this.handleAddressDefaultUpdated = (e) => {
      const newDefaultId = e?.detail || localStorage.getItem('DEFAULT_ADDRESS_ID');
      if (newDefaultId) {
        this.selectAddress(newDefaultId);
      }
      // Refresh addressData agar lat/lng yang baru tersimpan ikut terupdate
      if (this.getAddress) this.getAddress();
    };
    this.handleStorageChange = (e) => {
      if (e.key === 'DEFAULT_ADDRESS_ID' || e.key === 'CHECKOUT_SELECTED_ADDRESS_ID') {
        const newId = e.newValue;
        if (newId) {
          this.selectAddress(newId);
        }
      }
    };
    window.addEventListener('address:default_updated', this.handleAddressDefaultUpdated);
    window.addEventListener('storage', this.handleStorageChange);
    // Refresh alamat saat user kembali ke halaman checkout (misal setelah edit alamat)
    this.handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        if (this.getAddress) this.getAddress();
      }
    };
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentWillUnmount() {
    if (this.handleAddressDefaultUpdated) {
      window.removeEventListener('address:default_updated', this.handleAddressDefaultUpdated);
    }
    if (this.handleStorageChange) {
      window.removeEventListener('storage', this.handleStorageChange);
    }
    if (this.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
  }
  componentDidUpdate(prevProps) {
    const prevToken = prevProps ? (prevProps.token || localStorage.getItem('token')) : null;
    const currentToken = this.getActiveToken();

    if (currentToken && (!prevToken || prevToken !== currentToken)) {
      if (this.getSo) this.getSo();
      if (this.getAddress) this.getAddress();
      if (this.getCourier) this.getCourier();
      if (this.getBankList) this.getBankList();
    } else if (this.props.updateStatus && prevProps && prevProps.updateStatus !== this.props.updateStatus) {
      if (this.getSo) {
        this.getSo();
      }
    }
  }

  selectAddress = (addressId) => {
    if (!addressId) return;

    const isDifferent = String(this.state.address_id) !== String(addressId);

    sessionStorage.setItem('CHECKOUT_SELECTED_ADDRESS_ID', String(addressId));
    localStorage.setItem('CHECKOUT_SELECTED_ADDRESS_ID', String(addressId));

    if (isDifferent) {
      // Invalidate semua request hitung ongkir yang sedang berjalan (race condition prevention)
      this.ongkirRequestId = (this.ongkirRequestId || 0) + 1;
      this.itemRequestVersions = {};

      // Reset opsi pengiriman & ongkos kirim ke belum ditentukan
      const { listItem } = this.state;
      let pureProductTotal = 0;
      const resetList = (Array.isArray(listItem) ? listItem : []).map((item) => {
        const itemsSum = Array.isArray(item.items)
          ? item.items.reduce((acc, it) => acc + (parseFloat(it.sub_total) || 0), 0)
          : 0;
        const prodSub = itemsSum > 0
          ? itemsSum
          : Math.max(0, (parseFloat(item.sub_total_so) || parseFloat(item.payment_total) || 0) - (parseFloat(item.ongkir) || 0));

        pureProductTotal += prodSub;

        return {
          ...item,
          kurir_id: 0,
          ongkir: null,
          payment_total: prodSub,
        };
      });

      const resetListKurir = resetList.map((item) => ({ id: item.id, value: 0 }));

      this.setState({
        address_id: addressId,
        showOtherAddresses: false,
        show: false, // Tutup modal pembayaran jika sempat terbuka
        listkurir: resetListKurir,
        listItem: resetList,
        totalOngkir: 0,
        totalPrice: pureProductTotal,
        loadingOngkir: false,
        loadingOngkirId: null,
      });
    } else {
      this.setState({
        address_id: addressId,
        showOtherAddresses: false,
      });
    }
  };

  checkoutHandler = async (body) => {
    if (!this.state.address_id) {
      toast.warning('Silakan pilih alamat pengiriman terlebih dahulu', {
        toastId: 'checkout-addr-warning',
      });
      return;
    }
    if (!this.isOngkirDetermined()) {
      toast.warning('Silakan pilih opsi pengiriman dan cek ongkir terlebih dahulu', {
        toastId: 'checkout-ongkir-warning',
      });
      return;
    }
    if (this.state.loadingOngkir) {
      toast.warning('Sedang memperbarui ongkos kirim, silakan tunggu', {
        toastId: 'checkout-loading-warning',
      });
      return;
    }

    const activeToken = this.getActiveToken();
    const { history, dispatch } = this.props;
    let user_code = localStorage.getItem('user_code');

    if (!user_code) {
      try {
        const infoRes = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_HOST_API}/auth/info`,
          headers: {
            Authorization: `Bearer ${activeToken}`,
          },
        });
        if (infoRes.data?.response?.user_code) {
          user_code = infoRes.data.response.user_code;
          localStorage.setItem('user_code', user_code);
        }
      } catch (e) {
        console.error('Failed to get user_code in checkoutHandler:', e);
      }
    }

    let param = {
      user_code: user_code,
      account_number: body.bank_id,
      list_so: body.list_so,
    };

    try {
      this.setState({ loadingCO: true });
      const result = await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_HOST_API}/transaction/do-payment-product`,
        headers: {
          Authorization: `Bearer ${activeToken}`,
        },
        data: param,
      });
      this.setState({ loadingCO: false });
      const coResponse = result.data?.response;
      const orderId = coResponse?.id;
      const txCode = coResponse?.transaction_code;

      if (coResponse) {
        localStorage.setItem('CO-INFO', JSON.stringify(coResponse));
      }

      // Mulai timer batas pembayaran 24 jam saat order dibuat / diarahkan
      if (orderId || txCode) {
        initOrderTimer(orderId, txCode, Date.now());
      }

      sessionStorage.removeItem('CHECKOUT_SELECTED_ADDRESS_ID');
      localStorage.removeItem('CHECKOUT_SELECTED_ADDRESS_ID');
      toast.success(`${result.data.message}`);
      this.setState({ paid: true });
      dispatch(updateAction(true));
      setTimeout(() => {
        dispatch(updateAction(false));
      }, 100);

      // Alihkan langsung ke /account/order-produk/:id
      if (orderId) {
        history.push(`/account/order-produk/${orderId}`);
      } else {
        history.push('/shop/checkout/success');
      }
    } catch (error) {
      this.setState({ loadingCO: false });
      toast.error("Pilih pengiriman dahulu");
    }
  };

  cartUpdateKurirCok = async (listkurir, targetItemId = null, targetAddressId = null) => {
    const addressIdToUse = targetAddressId || this.state.address_id;
    if (!addressIdToUse) {
      toast.warning('Silakan pilih alamat pengiriman terlebih dahulu', {
        toastId: 'pilih-alamat-warning',
      });
      return;
    }

    // Catat request ID unik untuk proteksi race condition gonta-ganti alamat/kurir
    this.ongkirRequestId = (this.ongkirRequestId || 0) + 1;
    const currentRequestId = this.ongkirRequestId;
    const activeAddressAtCall = addressIdToUse;

    if (targetItemId) {
      this.itemRequestVersions = this.itemRequestVersions || {};
      this.itemRequestVersions[targetItemId] = currentRequestId;
    }

    const activeToken = this.getActiveToken();
    const { dispatch } = this.props;

    // Ambil koordinat dari addressData berdasarkan address yang dipilih
    const addressList = Array.isArray(this.state.addressData) ? this.state.addressData : [];
    let selectedAddr = addressList.find((a) => String(a.address_id) === String(addressIdToUse));
    let latitude = selectedAddr?.latitude || null;
    let longitude = selectedAddr?.longitude || null;

    // Jika koordinat belum terisi di state, ambil detail alamat langsung dari /address/get/{addressIdToUse}
    if ((latitude === null || latitude === undefined || String(latitude).trim() === '') && addressIdToUse) {
      try {
        const detailRes = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_HOST_API}/address/get/${addressIdToUse}`,
          headers: {
            Authorization: `Bearer ${activeToken}`,
          },
        });
        const detail = detailRes.data?.response;
        if (detail) {
          latitude = detail.latitude ?? null;
          longitude = detail.longitude ?? null;
          this.setState((prev) => ({
            addressData: (Array.isArray(prev.addressData) ? prev.addressData : []).map((a) =>
              String(a.address_id) === String(addressIdToUse)
                ? { ...a, ...detail, address_id: a.address_id }
                : a
            ),
          }));
        }
      } catch (e) {
        console.warn('Failed to load address detail on demand:', e);
      }
    }

    // Cek apakah alamat berubah saat proses pengambilan koordinat di atas
    if (
      this.ongkirRequestId !== currentRequestId ||
      String(this.state.address_id) !== String(activeAddressAtCall)
    ) {
      return;
    }

    const itemsToUpdate = (Array.isArray(listkurir) ? listkurir : []).filter((entry) => {
      if (targetItemId) return entry.id === targetItemId;
      return true;
    });

    if (itemsToUpdate.length === 0) {
      return;
    }

    this.setState({ loadingOngkir: true, loadingOngkirId: targetItemId });

    try {
      let hasSuccess = false;
      let hasError = false;
      let lastErrorMessage = '';

      await Promise.all(
        itemsToUpdate.map(async ({ id, value }) => {
          if (!value || Number(value) === 0) {
            return;
          }
          try {
            const pengirimanPayload = {
              kurir_id: value,
              address_id: addressIdToUse,
            };

            // Sertakan koordinat jika tersedia (backend butuh "titik poin alamat" untuk perhitungan jarak)
            if (latitude !== null && latitude !== undefined && String(latitude).trim() !== '') {
              pengirimanPayload.latitude = latitude;
            }
            if (longitude !== null && longitude !== undefined && String(longitude).trim() !== '') {
              pengirimanPayload.longitude = longitude;
            }

            await axios({
              method: 'POST',
              url: `${process.env.REACT_APP_HOST_API}/so-commerce/update-pengiriman/${id}`,
              headers: {
                Authorization: `Bearer ${activeToken}`,
              },
              data: pengirimanPayload,
            });
            hasSuccess = true;
          } catch (err) {
            hasError = true;
            lastErrorMessage = err.response?.data?.message || err.message || '';
            console.error(`Failed to update shipping for SO #${id}:`, err);
          }
        })
      );

      // Cek apakah user telah mengganti alamat atau kurir lain saat request berlangsung
      if (
        this.ongkirRequestId !== currentRequestId ||
        String(this.state.address_id) !== String(activeAddressAtCall)
      ) {
        // Discard stale response
        return;
      }

      this.setState({ loadingOngkir: false, loadingOngkirId: null });

      if (hasSuccess) {
        if (this.getSo) {
          await this.getSo(currentRequestId, activeAddressAtCall);
        }

        // Cek lagi setelah getSo selesai, pastikan user belum pindah alamat saat getSo berlangsung
        if (
          this.ongkirRequestId !== currentRequestId ||
          String(this.state.address_id) !== String(activeAddressAtCall)
        ) {
          return;
        }

        dispatch(updateAction(true));
        setTimeout(() => {
          dispatch(updateAction(false));
        }, 300);
      } else if (hasError) {
        // Reset pilihan kurir item yang gagal agar dropdown kembali ke 0
        if (targetItemId) {
          const revertListKurir = (Array.isArray(this.state.listkurir) ? this.state.listkurir : []).map((x) =>
            x.id === targetItemId ? { ...x, value: 0 } : x
          );
          const revertListItem = (Array.isArray(this.state.listItem) ? this.state.listItem : []).map((x) =>
            x.id === targetItemId ? { ...x, kurir_id: 0, ongkir: null } : x
          );
          this.setState({ listkurir: revertListKurir, listItem: revertListItem });
        }

        const addrId = selectedAddr?.address_id || addressIdToUse;
        const lowerMsg = String(lastErrorMessage).toLowerCase();
        const isCoordIssue =
          (!latitude || !longitude) &&
          (lowerMsg.includes('lokasi') ||
            lowerMsg.includes('titik') ||
            lowerMsg.includes('jarak') ||
            lowerMsg.includes('koordinat') ||
            lowerMsg.includes('kurir') ||
            lowerMsg.includes('alamat'));

        if (isCoordIssue) {
          toast.error(
            <span>
              Alamat belum memiliki titik lokasi (peta).{' '}
              <a
                href={`/account/addresses/${addrId}?from=checkout`}
                style={{ color: '#fff', textDecoration: 'underline', fontWeight: 'bold' }}
                onClick={() => sessionStorage.setItem('EDIT_ADDRESS_FROM', 'checkout')}
              >
                Edit alamat
              </a>{' '}
              dan tandai titik lokasi di peta.
            </span>,
            { toastId: 'missing-coords-warning', autoClose: 6000 }
          );
        } else {
          toast.error(lastErrorMessage || 'Gagal memperbarui ongkos kirim, silakan coba opsi kurir lain', {
            toastId: 'update-kurir-error',
          });
        }
      }
    } catch (error) {
      if (
        this.ongkirRequestId !== currentRequestId ||
        String(this.state.address_id) !== String(activeAddressAtCall)
      ) {
        return;
      }
      console.error('Error cartUpdateKurirCok:', error);
      this.setState({ loadingOngkir: false, loadingOngkirId: null });
      toast.error('Gagal memperbarui ongkos kirim', {
        toastId: 'update-kurir-error',
      });
    }
  };

  handlePaymentChange = (event) => {
    if (event.target.checked) {
      this.setState({ payment: event.target.value });
    }
  };



  // renderTotals() {
  //   const { cart } = this.props;

  //   if (cart.extraLines.length <= 0) {
  //     return null;
  //   }

  //   const extraLines = cart.extraLines.map((extraLine, index) => (
  //     <tr key={index}>
  //       <th>{extraLine.title}</th>
  //       <td>
  //         <Currency value={extraLine.price} />
  //       </td>
  //     </tr>
  //   ));

  //   const formatRupiah = (money) => {
  //     return new Intl.NumberFormat('id-ID',
  //         { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
  //     ).format(money);
  //   }
  //   return (

  //     <React.Fragment>

  //       <tbody className='checkout__totals-subtotals'>
  //         <tr>
  //           <th>Sub Total</th>
  //           <td>
  //             {formatRupiah(this.state.totalPrice)}
  //           </td>
  //         </tr>
  //         {/* <tr>
  //           <th>Biaya Pengiriman</th>
  //           <td>
  //             {formatRupiah(this.state.totalOngkir)}
  //           </td>
  //         </tr> */}
  //       </tbody>
  //     </React.Fragment>
  //   );
  // }

  renderTotals1() {

    const formatRupiah = (money) => {
      return new Intl.NumberFormat('id-ID',
        { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
      ).format(money);
    }
    return (

      <React.Fragment>
        <tr>
          <th>Sub Total</th>
          <th></th>
          <td>
            <b>{formatRupiah(this.state.totalPrice)}</b>
          </td>
        </tr>
        <tr>
          <th>Ongkir</th>
          <th></th>
          <td>
            <b>{formatRupiah(this.state.per_kg)}</b>
          </td>
        </tr>
      </React.Fragment>
    );
  }

  isOngkirDetermined = () => {
    const { listItem, listkurir } = this.state;
    if (!listItem || !Array.isArray(listItem) || listItem.length === 0) return false;

    // Setiap pesanan / toko di checkout harus sudah ditentukan kurir dan ongkirnya
    return listItem.every((item) => {
      // 1. Kurir harus sudah tersimpan di SO dari backend (kurir_id > 0)
      const savedKurirId = Number(item.kurir_id);
      if (!savedKurirId || savedKurirId <= 0) return false;

      // 2. Dropdown tidak boleh dalam kondisi kurir baru yang belum dicek / belum disimpan
      const currentSelection = listkurir?.find((x) => x.id === item.id);
      if (currentSelection && currentSelection.value !== undefined && currentSelection.value !== null) {
        if (Number(currentSelection.value) === 0) return false;
        if (Number(currentSelection.value) !== savedKurirId) return false;
      }

      // 3. Ongkir tidak boleh undefined atau null
      if (item.ongkir === null || item.ongkir === undefined) return false;

      return true;
    });
  };

  handleOpenPaymentModal = () => {
    if (!this.state.address_id) {
      toast.warning('Silakan pilih alamat pengiriman terlebih dahulu', {
        toastId: 'checkout-addr-warning',
      });
      return;
    }
    if (!this.isOngkirDetermined()) {
      toast.warning('Silakan pilih opsi pengiriman dan cek ongkir terlebih dahulu', {
        toastId: 'checkout-ongkir-warning',
      });
      return;
    }
    if (this.state.totalPrice <= 0) {
      toast.warning('Total tagihan belanja tidak valid', {
        toastId: 'checkout-total-warning',
      });
      return;
    }
    this.setState({ show: true });
  };

  getKurirasiu(item) {
    const { listkurir } = this.state;
    const kurir = listkurir.find((x) => x.id === item.id);

    return kurir ? kurir.value : item.kurir_id;

  }

  handleChangeKurir = async (item, kurirValue) => {
    const selectedKurirId = Number(kurirValue);

    // 1. Jika user memilih opsi reset (0 / "-- Pilih Jasa Pengiriman --")
    if (selectedKurirId === 0) {
      this.itemRequestVersions = this.itemRequestVersions || {};
      this.itemRequestVersions[item.id] = (this.itemRequestVersions[item.id] || 0) + 1;

      const currentList = Array.isArray(this.state.listkurir) ? [...this.state.listkurir] : [];
      const existingIndex = currentList.findIndex((x) => x.id === item.id);
      if (existingIndex >= 0) {
        currentList[existingIndex] = { id: item.id, value: 0 };
      } else {
        currentList.push({ id: item.id, value: 0 });
      }

      let newTotalOngkir = 0;
      let newTotalPrice = 0;
      const updatedItems = (Array.isArray(this.state.listItem) ? this.state.listItem : []).map((it) => {
        const itemsSum = Array.isArray(it.items)
          ? it.items.reduce((acc, x) => acc + (parseFloat(x.sub_total) || 0), 0)
          : 0;
        const prodSub = itemsSum > 0
          ? itemsSum
          : Math.max(0, (parseFloat(it.sub_total_so) || parseFloat(it.payment_total) || 0) - (parseFloat(it.ongkir) || 0));

        if (it.id === item.id) {
          newTotalPrice += prodSub;
          return {
            ...it,
            kurir_id: 0,
            ongkir: null,
            payment_total: prodSub,
          };
        }
        newTotalOngkir += (parseFloat(it.ongkir) || 0);
        newTotalPrice += (parseFloat(it.payment_total) || prodSub + (parseFloat(it.ongkir) || 0));
        return it;
      });

      this.setState({
        listkurir: currentList,
        listItem: updatedItems,
        totalOngkir: newTotalOngkir,
        totalPrice: newTotalPrice,
        loadingOngkir: false,
        loadingOngkirId: null,
        show: false,
      });
      return;
    }

    // 2. Guard: jika kurir yang sama sudah aktif & terhitung untuk pesanan ini, jangan hit berulang
    const currentSavedKurirId = Number(item.kurir_id);
    if (
      selectedKurirId === currentSavedKurirId &&
      item.ongkir !== null &&
      item.ongkir !== undefined &&
      !this.state.loadingOngkir
    ) {
      return;
    }

    // 3. Update listkurir di state
    const currentList = Array.isArray(this.state.listkurir) ? [...this.state.listkurir] : [];
    const existingIndex = currentList.findIndex((x) => x.id === item.id);
    if (existingIndex >= 0) {
      currentList[existingIndex] = { id: item.id, value: selectedKurirId };
    } else {
      currentList.push({ id: item.id, value: selectedKurirId });
    }

    this.setState({ listkurir: currentList });

    // 4. Jika user memilih opsi kurir valid (> 0) dan alamat sudah ada, langsung load ongkirnya!
    if (!this.state.address_id) {
      toast.warning('Silakan pilih alamat pengiriman terlebih dahulu', {
        toastId: 'pilih-alamat-warning',
      });
      return;
    }

    await this.cartUpdateKurirCok(currentList, item.id);
  };

  formatRupiah = (money) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
    }).format(money || 0);
  };

  renderCart1() {
    const { listkurir, listItem, courier } = this.state;

    if (!listItem || listItem.length === 0) {
      return (
        <EmptyState
          compact
          icon="shopping-bag"
          title="Belum ada pesanan"
          text="Pilih produk di keranjang dulu, ya."
          actionLabel="Ke Keranjang"
          actionTo="/cart"
          actionIcon="shopping-cart"
        />
      );
    }

    return (
      <div className="hokky-checkout-orders-list">
        {listItem.map((item, index) => {
          // Calculate actual product subtotal (sum of items)
          const itemsSum = Array.isArray(item.items)
            ? item.items.reduce((acc, it) => acc + (parseFloat(it.sub_total) || 0), 0)
            : 0;

          const productSubtotal = itemsSum > 0
            ? itemsSum
            : Math.max(0, (parseFloat(item.sub_total_so) || parseFloat(item.payment_total) || 0) - (parseFloat(item.ongkir) || 0));

          return (
            <div key={item.id || index} className="hokky-checkout-store-block">
              <div className="hokky-checkout-store-header">
                <div className="store-badge-box">
                  <i className="fas fa-store" />
                </div>
                <span className="store-name">{item.warehouse_name || 'Hokky Bangunan'}</span>
              </div>

              <div className="hokky-checkout-items-list">
                {item.items && item.items.map((listItem, listIndex) => (
                  <div key={listItem.id || listIndex} className="hokky-checkout-item-row">
                    <div className="item-thumb">
                      <img
                        src={listItem.image_url || '/images/products/placeholder.jpg'}
                        alt={listItem.item_name}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/images/products/placeholder.jpg';
                        }}
                      />
                    </div>
                    <div className="item-details">
                      <div className="item-name">{listItem.item_name}</div>
                      <div className="item-meta">
                        <span
                          className={`hokky-status-badge ${String(listItem.status || '').trim().toUpperCase() === 'INDEN' ||
                              (listItem.stok != null && Number(listItem.stok) <= 0)
                              ? 'hokky-status-badge--inden'
                              : 'hokky-status-badge--ready'
                            }`}
                        >
                          {String(listItem.status || '').trim().toUpperCase() === 'INDEN' ||
                            (listItem.stok != null && Number(listItem.stok) <= 0)
                            ? 'Inden'
                            : 'Ready'}
                        </span>
                        <span className="item-qty">{listItem.qty} barang</span>
                        <span className="item-unit-price">
                          {this.formatRupiah(listItem.price || (listItem.sub_total / (listItem.qty || 1)))}
                        </span>
                      </div>
                    </div>
                    <div className="item-subtotal">
                      {this.formatRupiah(listItem.sub_total)}
                    </div>
                  </div>
                ))}
              </div>

              <div className="hokky-checkout-shipping-box">
                <div className="shipping-label">
                  <i className="fas fa-truck mr-1" /> Pilih Opsi Pengiriman:
                </div>
                <div className="shipping-controls">
                  <div className="shipping-select-wrapper">
                    <select
                      className="hokky-checkout-select"
                      value={this.getKurirasiu(item)}
                      onChange={(e) => this.handleChangeKurir(item, e.target.value)}
                      disabled={this.state.loadingOngkir && (!this.state.loadingOngkirId || this.state.loadingOngkirId === item.id)}
                    >
                      <option value={0}>-- Pilih Jasa Pengiriman --</option>
                      {courier.map((res) => (
                        <option key={res.id} value={res.id}>{res.name}</option>
                      ))}
                    </select>
                    {this.state.loadingOngkir && (!this.state.loadingOngkirId || this.state.loadingOngkirId === item.id) && (
                      <div className="shipping-select-spinner">
                        <i className="fas fa-spinner fa-spin" />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="hokky-checkout-store-summary">
                <div className="summary-row">
                  <span>Subtotal Produk</span>
                  <span className="font-weight-bold">{this.formatRupiah(productSubtotal)}</span>
                </div>
                <div className="summary-row">
                  <span>Ongkos Kirim</span>
                  <span className="font-weight-bold">
                    {!item.kurir_id || Number(item.kurir_id) <= 0 || item.ongkir === null || item.ongkir === undefined ? (
                      <span className="text-muted font-weight-normal small">Belum ditentukan</span>
                    ) : (
                      this.formatRupiah(item.ongkir)
                    )}
                  </span>
                </div>
                <div className="summary-row summary-total">
                  <span>Total Pesanan</span>
                  <span className="total-amount">{this.formatRupiah(item.payment_total)}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  getBankTheme = (bankName = '') => {
    const name = String(bankName).toUpperCase();
    if (name.includes('BCA')) {
      return { bg: '#005baa', color: '#ffffff', label: 'BCA', sub: 'Bank Central Asia' };
    }
    if (name.includes('MANDIRI')) {
      return { bg: '#002f6c', color: '#ffffff', label: 'MANDIRI', sub: 'Bank Mandiri' };
    }
    if (name.includes('BRI')) {
      return { bg: '#00529c', color: '#ffffff', label: 'BRI', sub: 'Bank Rakyat Indonesia' };
    }
    if (name.includes('JATIM')) {
      return { bg: '#c91f28', color: '#ffffff', label: 'BANK JATIM', sub: 'Bank Jatim' };
    }
    if (name.includes('BNI')) {
      return { bg: '#f15a24', color: '#ffffff', label: 'BNI', sub: 'Bank Negara Indonesia' };
    }
    return { bg: '#002b66', color: '#ffffff', label: bankName || 'BANK', sub: 'Transfer Bank' };
  };

  renderPaymentsList() {
    const { payment: currentPayment, listBank } = this.state;

    if (!listBank || listBank.length === 0) {
      return (
        <div className="text-center py-4 text-muted">
          <i className="fas fa-spinner fa-spin mr-2 text-primary" /> Memuat pilihan pembayaran...
        </div>
      );
    }

    return (
      <div className="hokky-payment-list">


        {listBank.map((bank) => {
          const isSelected = currentPayment === bank.account_number;
          const theme = this.getBankTheme(bank.bank_name);

          return (
            <div
              key={bank.account_number}
              className={`hokky-bank-card ${isSelected ? 'hokky-bank-card--selected' : ''}`}
              onClick={() => this.setState({ payment: bank.account_number })}
              role="button"
              tabIndex={0}
            >
              <div className="hokky-bank-card__left">
                <span
                  className="hokky-bank-badge"
                  style={{ backgroundColor: theme.bg, color: theme.color }}
                >
                  {theme.label}
                </span>
                <div className="hokky-bank-info">
                  <div className="hokky-bank-title">{bank.bank_name}</div>
                  <div className="hokky-bank-subtitle">
                    {bank.account_number ? (
                      <span className="hokky-acc-num">{bank.account_number}</span>
                    ) : (
                      theme.sub
                    )}
                  </div>
                </div>
              </div>

              <div className="hokky-bank-card__right">
                <div className="hokky-custom-radio">
                  <div className="hokky-custom-radio__dot" />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  toggleModal = () => {
    this.setState({ show: false });
  };

  renderCart2() {
    const { listItem, totalOngkir, totalPrice } = this.state;
    let totalProductPrice = 0;

    if (Array.isArray(listItem)) {
      listItem.forEach((item) => {
        const itemsSum = Array.isArray(item.items)
          ? item.items.reduce((acc, it) => acc + (parseFloat(it.sub_total) || 0), 0)
          : 0;

        const prodSub = itemsSum > 0
          ? itemsSum
          : Math.max(0, (parseFloat(item.sub_total_so) || parseFloat(item.payment_total) || 0) - (parseFloat(item.ongkir) || 0));
        totalProductPrice += prodSub;
      });
    }

    if (totalProductPrice === 0) {
      totalProductPrice = Math.max(0, totalPrice - totalOngkir);
    }

    return (
      <div className="hokky-checkout-summary-body">
        <div className="summary-row">
          <span className="label">Total Harga Barang</span>
          <span className="val">{this.formatRupiah(totalProductPrice)}</span>
        </div>
        <div className="summary-row">
          <span className="label">Total Ongkos Kirim</span>
          <span className="val">
            {!this.isOngkirDetermined() ? (
              <span className="text-muted font-weight-normal small">Belum ditentukan</span>
            ) : (
              this.formatRupiah(totalOngkir)
            )}
          </span>
        </div>
        <div className="summary-row total-row">
          <span className="label">Total Tagihan</span>
          <span className="val-total">{this.formatRupiah(totalPrice)}</span>
        </div>
      </div>
    );
  }

  render() {
    const breadcrumb = [
      { title: 'Home', url: '' },
      { title: 'Keranjang', url: '/cart' },
      { title: 'Checkout', url: '' },
    ];

    if (this.state.loadingInit) {
      return (
        <React.Fragment>
          <Helmet>
            <title>{`Checkout | ${theme.name}`}</title>
          </Helmet>
          <div className='hokky-checkout-page-block'>
            <PageHeader breadcrumb={breadcrumb} />
            <div className='container hokky-cart-container' style={{ pointerEvents: 'none' }}>
              <div className='row'>
                <div className='col-12 col-lg-8'>
                  {/* Skeleton Card 1: Alamat Pengiriman */}
                  <div className='hokky-checkout-section-card'>
                    <div className='hokky-checkout-section-header justify-content-between'>
                      <div className='d-flex align-items-center'>
                        <div className='skeleton-bone skeleton-bone--circle' style={{ width: 24, height: 24, marginRight: 12 }} />
                        <div className='skeleton-bone' style={{ width: 160, height: 20, borderRadius: 4 }} />
                      </div>
                    </div>
                    <div className='address-selected-box-modern' style={{ background: '#f8fafc', border: '1.5px solid #e2e8f0', padding: 20, borderRadius: 14 }}>
                      <div className='d-flex justify-content-between align-items-center mb-3'>
                        <div className='skeleton-bone' style={{ width: 140, height: 20, borderRadius: 4 }} />
                        <div className='skeleton-bone' style={{ width: 90, height: 28, borderRadius: 8 }} />
                      </div>
                      <div className='skeleton-bone' style={{ width: '85%', height: 16, borderRadius: 4, marginBottom: 8 }} />
                      <div className='skeleton-bone' style={{ width: '60%', height: 16, borderRadius: 4 }} />
                    </div>
                  </div>

                  {/* Skeleton Card 2: Pesanan & Pengiriman */}
                  <div className='hokky-checkout-section-card'>
                    <div className='hokky-checkout-section-header'>
                      <div className='skeleton-bone skeleton-bone--circle' style={{ width: 24, height: 24, marginRight: 12 }} />
                      <div className='skeleton-bone' style={{ width: 140, height: 20, borderRadius: 4 }} />
                    </div>
                    <div className='p-3'>
                      <div className='d-flex align-items-center mb-3 pb-2' style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <div className='skeleton-bone' style={{ width: 28, height: 28, borderRadius: 6, marginRight: 10 }} />
                        <div className='skeleton-bone' style={{ width: 180, height: 18, borderRadius: 4 }} />
                      </div>
                      {[1, 2].map((idx) => (
                        <div key={idx} className='d-flex align-items-center mb-3 pb-3' style={{ borderBottom: '1px solid #f8fafc', gap: 14 }}>
                          <div className='skeleton-bone' style={{ width: 64, height: 64, borderRadius: 10, flexShrink: 0 }} />
                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
                            <div className='skeleton-bone' style={{ width: '70%', height: 16, borderRadius: 4 }} />
                            <div className='skeleton-bone' style={{ width: '30%', height: 14, borderRadius: 4 }} />
                            <div className='skeleton-bone' style={{ width: '40%', height: 18, borderRadius: 4 }} />
                          </div>
                        </div>
                      ))}
                      <div className='skeleton-bone' style={{ width: '100%', height: 44, borderRadius: 10, marginTop: 12 }} />
                    </div>
                  </div>
                </div>

                {/* Skeleton Right Column: Summary Card */}
                <div className='col-12 col-lg-4 mt-4 mt-lg-0'>
                  <div className='hokky-summary-card' style={{ padding: 24, borderRadius: 16, background: '#ffffff', border: '1px solid #e2e8f0' }}>
                    <div className='skeleton-bone' style={{ width: 150, height: 22, borderRadius: 4, marginBottom: 20 }} />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 14, padding: '16px 0', borderTop: '1px solid #f1f5f9', borderBottom: '1px solid #f1f5f9' }}>
                      <div className='d-flex justify-content-between'>
                        <div className='skeleton-bone' style={{ width: 80, height: 16, borderRadius: 4 }} />
                        <div className='skeleton-bone' style={{ width: 110, height: 16, borderRadius: 4 }} />
                      </div>
                      <div className='d-flex justify-content-between'>
                        <div className='skeleton-bone' style={{ width: 90, height: 16, borderRadius: 4 }} />
                        <div className='skeleton-bone' style={{ width: 90, height: 16, borderRadius: 4 }} />
                      </div>
                      <div className='d-flex justify-content-between pt-2'>
                        <div className='skeleton-bone' style={{ width: 60, height: 18, borderRadius: 4 }} />
                        <div className='skeleton-bone' style={{ width: 130, height: 24, borderRadius: 5 }} />
                      </div>
                    </div>
                    <div className='skeleton-bone' style={{ width: '100%', height: 48, borderRadius: 12, marginTop: 20 }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }

    if (!this.state.loadingInit && (!this.state.listItem || this.state.listItem.length === 0)) {
      return (
        <React.Fragment>
          <Helmet>
            <title>{`Checkout | ${theme.name}`}</title>
          </Helmet>
          <div className='hokky-checkout-page-block'>
            <PageHeader breadcrumb={breadcrumb} />
            <div className='container hokky-cart-container'>
              <EmptyState
                icon="cart"
                title="Belum ada pesanan"
                text="Pilih produk di keranjang dulu, ya."
                actionLabel="Ke Keranjang"
                actionTo="/cart"
                actionIcon="shopping-cart"
              />
            </div>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>{`Checkout | ${theme.name}`}</title>
        </Helmet>

        <div className='hokky-checkout-page-block'>
          <PageHeader breadcrumb={breadcrumb} />

          <div className='container hokky-cart-container'>
            <div className='row'>
              <div className='col-12 col-lg-8'>
                {/* Card 1: Alamat Pengiriman */}
                <div className='hokky-checkout-section-card'>
                  <div className='hokky-checkout-section-header justify-content-between flex-wrap'>
                    <div className='d-flex align-items-center'>
                      <i className='fas fa-map-marker-alt section-icon mr-3' />
                      <h3 className='section-title'>Alamat Pengiriman</h3>
                    </div>

                    {Array.isArray(this.state.addressData) && this.state.addressData.length > 1 && (
                      <button
                        type='button'
                        className='btn-toggle-alamat-lain'
                        onClick={() => this.setState((prev) => ({ showOtherAddresses: !prev.showOtherAddresses }))}
                      >
                        <i className={`fas ${this.state.showOtherAddresses ? 'fa-check' : 'fa-exchange-alt'} mr-1.5`} />
                        {this.state.showOtherAddresses ? 'Selesai Memilih' : 'Pilih Alamat Lain'}
                      </button>
                    )}
                  </div>

                  {Array.isArray(this.state.addressData) && this.state.addressData.length > 0 ? (
                    (() => {
                      const list = this.state.addressData;
                      const defaultAddrId = localStorage.getItem('DEFAULT_ADDRESS_ID');

                      // Temukan alamat yang dipilih atau alamat utama
                      const selectedAddress =
                        list.find((a) => String(a.address_id) === String(this.state.address_id)) ||
                        (defaultAddrId && list.find((a) => String(a.address_id) === String(defaultAddrId))) ||
                        list.find((a) => a.is_default === 0 || a.is_default === '0') ||
                        list[0];

                      // Sort list agar alamat utama selalu tampil di paling atas saat membuka pilihan alamat lain
                      const sortedList = [...list].sort((a, b) => {
                        const aIsDef = defaultAddrId != null
                          ? String(a.address_id) === String(defaultAddrId)
                          : (a.is_default === 0 || a.is_default === '0');
                        const bIsDef = defaultAddrId != null
                          ? String(b.address_id) === String(defaultAddrId)
                          : (b.is_default === 0 || b.is_default === '0');
                        if (aIsDef && !bIsDef) return -1;
                        if (!aIsDef && bIsDef) return 1;
                        return 0;
                      });

                      // 1. TAMPILAN UTAMA SAJA (Default saat belum klik pilih alamat lain)
                      if (!this.state.showOtherAddresses && selectedAddress) {
                        const isUtama = defaultAddrId != null
                          ? String(selectedAddress.address_id) === String(defaultAddrId)
                          : (selectedAddress.is_default === 0 || selectedAddress.is_default === '0');
                        const fullAddress = [
                          selectedAddress.address_name,
                          selectedAddress.city_name,
                          selectedAddress.province_name,
                          selectedAddress.postal_code,
                        ]
                          .filter((v) => v && String(v).trim() !== '')
                          .join(', ');

                        return (
                          <div className='hokky-checkout-address-single-view'>
                            <div className='hokky-checkout-address-card is-selected'>
                              <div className='address-card-header'>
                                <div className='address-header-left'>
                                  <span className='selected-indicator-icon'>
                                    <i className='fas fa-check-circle' />
                                  </span>
                                  {isUtama && (
                                    <span className='hokky-icon-badge-utama' title='Alamat Utama'>
                                      <i className='fas fa-star' />
                                    </span>
                                  )}
                                  <span className='recipient-name'>
                                    {selectedAddress.recipient_name || 'Alamat Penerima'}
                                  </span>
                                  {selectedAddress.phone && (
                                    <span className='recipient-phone'>• {selectedAddress.phone}</span>
                                  )}
                                </div>

                                <div className='d-flex align-items-center gap-2'>
                                  <Link
                                    to={`/account/addresses/${selectedAddress.address_id}?from=checkout`}
                                    onClick={() => sessionStorage.setItem('EDIT_ADDRESS_FROM', 'checkout')}
                                    className='btn-address-edit'
                                  >
                                    <i className='far fa-edit mr-1' /> Edit
                                  </Link>
                                </div>
                              </div>

                              <div className='address-card-content'>
                                <p className='address-full-text'>
                                  {fullAddress || 'Detail alamat belum lengkap'}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      }

                      // 2. TAMPILAN PILIHAN ALAMAT LAIN (Muncul saat tombol diklik)
                      return (
                        <div className='hokky-checkout-addresses-list'>
                          <div className='mb-2.5 px-1'>
                            <span className='address-selector-helper'>
                              Pilih salah satu alamat pengiriman untuk pesanan ini:
                            </span>
                          </div>
                          {sortedList.map((address, idx) => {
                            const isSelected = String(this.state.address_id) === String(address.address_id);
                            const isUtama = defaultAddrId != null
                              ? String(address.address_id) === String(defaultAddrId)
                              : (address.is_default === 0 || address.is_default === '0');
                            const fullAddress = [
                              address.address_name,
                              address.city_name,
                              address.province_name,
                              address.postal_code,
                            ]
                              .filter((v) => v && String(v).trim() !== '')
                              .join(', ');

                            return (
                              <div
                                key={address.address_id || idx}
                                className={`hokky-checkout-address-card ${isSelected ? 'is-selected' : ''}`}
                                onClick={() => this.selectAddress(address.address_id)}
                              >
                                <div className='address-card-header'>
                                  <div className='address-header-left'>
                                    <label className='hokky-radio-wrapper' onClick={(e) => e.stopPropagation()}>
                                      <input
                                        type='radio'
                                        name='address'
                                        value={address.address_id}
                                        checked={isSelected}
                                        onChange={() => this.selectAddress(address.address_id)}
                                        className='hokky-radio-input'
                                      />
                                      <span className='hokky-radio-circle' />
                                    </label>
                                    {isUtama && (
                                      <span className='hokky-icon-badge-utama' title='Alamat Utama'>
                                        <i className='fas fa-star' />
                                      </span>
                                    )}
                                    <span className='recipient-name'>
                                      {address.recipient_name || 'Alamat Penerima'}
                                    </span>
                                    {address.phone && (
                                      <span className='recipient-phone'>• {address.phone}</span>
                                    )}
                                  </div>

                                  <div className='d-flex align-items-center gap-2'>
                                    {isSelected && (
                                      <span className='hokky-icon-badge-terpilih mr-2' title='Alamat Terpilih'>
                                        <i className='fas fa-check' />
                                      </span>
                                    )}
                                    <Link
                                      to={`/account/addresses/${address.address_id}?from=checkout`}
                                      className='btn-address-edit'
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        sessionStorage.setItem('EDIT_ADDRESS_FROM', 'checkout');
                                      }}
                                    >
                                      <i className='far fa-edit mr-1' /> Ubah Alamat
                                    </Link>
                                  </div>
                                </div>

                                <div className='address-card-content'>
                                  <p className='address-full-text'>
                                    {fullAddress || 'Detail alamat belum lengkap'}
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()
                  ) : (
                    <EmptyState
                      compact
                      icon="map-marker-alt"
                      title="Belum ada alamat"
                      text="Tambahkan alamat pengiriman dulu."
                      actionLabel="Tambah Alamat"
                      actionTo="/account/addresses/5?from=checkout"
                      actionIcon="plus"
                    />
                  )}
                </div>

                {/* Card 2: Pesanan */}
                <div className='hokky-checkout-section-card'>
                  <div className='hokky-checkout-section-header'>
                    <i className='fas fa-box section-icon' />
                    <h3 className='section-title'>Pesanan</h3>
                  </div>

                  {this.renderCart1()}
                </div>
              </div>

              {/* Right Column: Sticky Summary */}
              <div className='col-12 col-lg-4 mt-4 mt-lg-0'>
                <div className='hokky-summary-card'>
                  <h4 className='summary-title'>Ringkasan Belanja</h4>

                  {this.renderCart2()}

                  <button
                    type='button'
                    className='btn-hokky-primary'
                    onClick={this.handleOpenPaymentModal}
                    disabled={!this.state.address_id || this.state.totalPrice <= 0 || !this.isOngkirDetermined() || this.state.loadingOngkir}
                    title={
                      !this.state.address_id
                        ? 'Pilih alamat pengiriman terlebih dahulu'
                        : !this.isOngkirDetermined()
                          ? 'Tentukan opsi pengiriman & cek ongkir terlebih dahulu'
                          : 'Lanjut ke pemilihan metode pembayaran'
                    }
                  >
                    Pilih Pembayaran
                  </button>

                  {!this.state.address_id ? (
                    <div className="text-muted small text-center mt-2">
                      <i className="fas fa-info-circle mr-1 text-primary" /> Silakan pilih alamat pengiriman
                    </div>
                  ) : !this.isOngkirDetermined() ? (
                    <div className="text-muted small text-center mt-2">
                      <i className="fas fa-info-circle mr-1 text-primary" /> Tentukan opsi pengiriman &amp; cek ongkir terlebih dahulu
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modal Pembayaran */}
        <Modal
          isOpen={this.state.show}
          toggle={this.toggleModal}
          fade={false}
          centered
          className="hokky-payment-modal"
        >
          <ModalHeader toggle={this.toggleModal} className="d-flex justify-content-between align-items-center">
            <div className="modal-title-wrap">
              <h4 className="mb-0 font-weight-bold">Metode Pembayaran</h4>

            </div>
          </ModalHeader>
          <ModalBody>
            {this.renderPaymentsList()}
          </ModalBody>
          <ModalFooter>
            <div className="modal-total-row">
              <span className="modal-total-label">Total Pembayaran:</span>
              <span className="modal-total-val">{this.formatRupiah(this.state.totalPrice)}</span>
            </div>
            <button
              type='button'
              disabled={this.state.loadingCO || !this.state.payment}
              className={classNames('btn-hokky-primary', { 'btn-loading': this.state.loadingCO })}
              onClick={() => {
                this.checkoutHandler({
                  bank_id: this.state.payment,
                  address_id: this.state.address_id,
                  list_so: this.state.list_so,
                });
              }}
            >
              {this.state.loadingCO ? (
                <i className="fas fa-spinner fa-spin" />
              ) : (
                'Beli Sekarang'
              )}
            </button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  // cart: state.cart,
  // cart: state.cart,
  token: state.auth.token,
  updateStatus: state.auth.update
});

const mapDispatchToProps = {
  // cartRemoveItem,
  // cartUpdateQuantities,
};

export default connect(mapStateToProps, mapDispatchToProps)(dispatchFunc(historyFunc(ShopPageCheckout)));
